import { Component } from '@angular/core';
import { ICellRendererAngularComp, IHeaderAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IHeaderParams } from 'ag-grid-community';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-scenario-formatter-renderer',
  template: `
    <pt-level-formatter [level]='level' [label]="value"></pt-level-formatter>
  `
})
export class ScenarioFormatterRendererComponent implements ICellRendererAngularComp, IHeaderAngularComp {

  params: any;
  IconCheck = IoniconsOutline.check;
  level: any;
  value: string;

  agInit(params: any): void {
    this.params = params;
    this.value = this.params.value;
    const enumKey = this.params.enumKey;
    if (enumKey) {
      this.level = this.params.data[enumKey];
    }
  }

  refresh(params: ICellRendererParams): boolean;
  refresh(params: IHeaderParams): boolean;
  refresh(params: ICellRendererParams | IHeaderParams): boolean {
    return false;
  }
}

